/**
 * Whether Advanced mode is offered to this visitor: the admin has switched it
 * on for everyone, or this browser carries the beta flag (the hidden hot key).
 */

import { useAppSettings } from '../../../context/AppSettingsContext';
import { useAdvancedDesignerFlag } from '../../../utils/advancedDesignerFlag';

export function useAdvancedDesignerEnabled(): boolean {
  const { settings } = useAppSettings();
  const beta = useAdvancedDesignerFlag();
  return settings.advancedDesignerEnabled || beta;
}
